<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyStatus="filterProps.status"
      :keyType="filterProps.type"
      :keyClickType="filterProps.clickType"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyStatus="filterProps.status"
        :keyType="filterProps.type"
        :keyClickType="filterProps.clickType"
        @clearKey="clearKey"
        @addNew="addNew"
      />
      <router-view
        v-if="isSysRights('SupplierMallAD.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        @deleteAD="deleteAD"
        @editAD="editAD"
        @move="move"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/mall-AD/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalNewAD'"
        :home="false"
        :loading="modalNewAD.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.添加新广告") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <form>
              <div class="form-group row mg-b-5">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.广告类型：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <select
                    class="form-control form-control-sm"
                    v-model="modalNewAD.type"
                  >
                    <option value="">{{ $t("mall.广告类型") }}</option>
                    <option v-for="(s, k) in $dict.ADtype" :key="k" :value="k">
                      {{ $t(s) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row mg-b-15">
                <div class="col-md-3"></div>
                <div class="col-md-8 col-sm-12 tx-danger">
                  <span v-if="modalNewAD.type != '' && modalNewAD.type != 6">{{
                    $t("mall.建议尺寸：")
                  }}</span>
                  {{ ADSize[modalNewAD.type] }}
                </div>
              </div>
              <div class="form-group row mg-b-15">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.点击类型：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <select
                    class="form-control form-control-sm"
                    v-model="modalNewAD.clickType"
                  >
                    <option value="">{{ $t("mall.点击类型") }}</option>
                    <option
                      v-for="(s, k) in $dict.ADclickType"
                      :key="k"
                      :value="k"
                    >
                      {{ $t(s) }}
                    </option>
                  </select>
                </div>
              </div>
              <template v-if="modalNewAD.clickType == 1">
                <div class="form-group row mg-b-15">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.商品名包含：") }}
                  </label>
                  <div
                    class="
                      col-md-8 col-sm-12
                      d-flex
                      align-items-center
                      pd-0
                      mg-l-10
                    "
                  >
                    <input
                      v-model="modalNewAD.productName"
                      type="text"
                      :placeholder="$t('mall.请输入商品名')"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
                <div class="form-group row mg-b-15">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.价格范围段：") }}
                  </label>
                  <div
                    class="
                      col-md-8 col-sm-12
                      d-flex
                      align-items-center
                      pd-0
                      mg-l-10
                    "
                  >
                    <input
                      v-model="modalNewAD.priceRange1"
                      type="text"
                      :placeholder="$t('mall.请输入价格')"
                      class="form-control form-control-sm wd-100"
                    />
                    <span class="mg-x-10">---</span>
                    <input
                      v-model="modalNewAD.priceRange2"
                      type="text"
                      :placeholder="$t('mall.请输入价格')"
                      class="form-control form-control-sm wd-100"
                    />
                  </div>
                </div>
                <div class="form-group row mg-b-15">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.商品标签：") }}
                  </label>
                  <div class="col-md-7 d-flex align-items-center pd-0">
                    <div style="word-break: break-all" class="pd-l-10">
                      {{ modalNewAD.cIdName ? modalNewAD.cIdName : "---" }}
                    </div>
                  </div>
                  <div class="col-md-2">
                    <a
                      href="javascript:;"
                      class="tx-info mg-l-20"
                      @click="modalNewADLabel"
                      >{{
                        modalNewAD.cIdName
                          ? $t("mall.修改标签")
                          : $t("mall.添加标签")
                      }}</a
                    >
                  </div>
                </div>
              </template>
              <template v-if="modalNewAD.clickType == 2">
                <div class="form-group row mg-b-15">
                  <label
                    class="col-md-3 col-form-label form-control-sm text-right"
                  >
                    {{ $t("mall.页面地址：") }}
                  </label>
                  <div
                    class="
                      col-md-8 col-sm-12
                      d-flex
                      align-items-center
                      pd-0
                      mg-l-10
                    "
                  >
                    <input
                      v-model="modalNewAD.urlPath"
                      type="text"
                      :placeholder="$t('mall.请输入页面地址')"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </template>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.广告状态：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <label
                    class="rdiobox mg-r-30"
                    v-for="(s, k) in $dict.ADStatus"
                    :key="k"
                  >
                    <input
                      type="radio"
                      name="uploadStatus"
                      :value="k"
                      v-model="modalNewAD.status"
                    />
                    <span>{{ $t(s) }}</span>
                  </label>
                </div>
              </div>
              <div class="form-group row mg-b-0">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                  {{ $t("mall.图片：") }}
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <label class="rdiobox mg-r-30">
                    <input
                      type="radio"
                      name="uploadType"
                      value="1"
                      v-model="modalNewAD.uploadType"
                    />
                    <span>{{ $t("mall.图片") }}</span>
                  </label>
                  <label
                    class="rdiobox"
                    v-if="modalNewAD.type != 5 && modalNewAD.type != 6"
                  >
                    <input
                      type="radio"
                      name="uploadType"
                      value="2"
                      v-model="modalNewAD.uploadType"
                    />
                    <span>{{ $t("mall.视频") }}</span>
                  </label>
                </div>
              </div>
              <div class="form-group row mg-b-10">
                <label
                  class="col-md-3 col-form-label form-control-sm text-right"
                >
                </label>
                <div
                  class="
                    col-md-8 col-sm-12
                    d-flex
                    align-items-center
                    pd-0
                    mg-l-10
                  "
                >
                  <div
                    v-if="modalNewAD.uploadType == 1"
                    class="pos-relative upload-img-wrap mg-r-30"
                  >
                    <a
                      class="upload-img mg-r-15"
                      href="javascript:;"
                      v-lazy:background-image="modalNewAD.imgUrl"
                      :style="{
                        backgroundSize: scale ? '100% auto' : 'auto 100%',
                      }"
                      style="
                        background-position: center;
                        background-repeat: no-repeat;
                        border: 1px solid #ddd;
                      "
                    >
                    </a>
                    <button
                      type="button"
                      class="btn btn-success tx-12 btn-sm mg-b-0"
                      @click="fileClick()"
                    >
                      {{ $t("mall.上传图片") }}
                    </button>
                    <input
                      v-if="modalNewAD.type != 6"
                      @change="imgBase64($event)"
                      type="file"
                      name="upload_file"
                      id="upload_file_btn2"
                      class="file-input"
                      accept=".jpg,.png,.gif"
                      style="display: none"
                    />
                    <input
                      v-if="modalNewAD.type == 6"
                      @change="imgBase64($event)"
                      type="file"
                      name="upload_file"
                      id="upload_file_btn2"
                      class="file-input"
                      accept="image/x-icon,image/png"
                      style="display: none"
                    />
                  </div>
                  <div
                    v-if="modalNewAD.uploadType == 2"
                    class="d-flex align-items-center"
                  >
                    <div class="mg-r-15">
                      <video
                        id="video"
                        width="400"
                        height="300"
                        controls="controls"
                        :src="modalNewAD.imgUrl"
                      ></video>
                    </div>
                    <div class="">
                      <button
                        type="button"
                        class="btn btn-success tx-12 btn-sm mg-b-0"
                        @click="fileClick2()"
                      >
                        {{ $t("mall.上传视频") }}
                      </button>
                      <input
                        @change="fileUpload($event)"
                        type="file"
                        name="upload_file"
                        class="uploadVideo_input"
                        id="upload_file_btn3"
                        accept="video/mp4"
                        style="display: none"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveNewAD()"
              >
                {{ $t("mall.确定") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalMallLabel'"
        :home="false"
        :loading="modalMallLabel.loading"
        :size="'lg'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("mall.选择商品标签") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="form-group row mg-b-10">
              <p class="col-12 mg-b-0">{{ $t("mall.选择要加入的标签") }}:</p>
            </div>
            <div class="form-group row mg-b-10">
              <div
                class="col-12"
                v-for="(item, index) in modalMallLabel.list"
                :key="index"
              >
                <label class="c-checkbox-wrap">
                  <input
                    type="radio"
                    :value="item.id"
                    v-model="modalNewAD.cId"
                  />
                  <div class="c-checkbox">
                    <i class="ion-android-checkbox-blank"></i>
                    <span style="word-break: break-all">{{ item.name }}</span>
                  </div>
                </label>
                <div
                  class="col-12"
                  v-if="item.chlidren && item.chlidren.length > 0"
                >
                  <label
                    v-for="stock in item.chlidren"
                    :key="stock.id"
                    class="c-checkbox-wrap"
                  >
                    <input
                      type="radio"
                      :value="stock.id"
                      v-model="modalNewAD.cId"
                    />
                    <div class="c-checkbox">
                      <i class="ion-android-checkbox-blank"></i>
                      <span style="word-break: break-all">{{
                        stock.name
                      }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-15
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveNewADLabel()"
              >
                {{ $t("mall.确定") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("mall.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <confirmComponent
        @del_index_i="deletesFn"
        :modal_id="delAddr.modalId"
        :modal_title="delAddr.title"
        :modal_text="delAddr.text"
        :del_index="delAddr.delIndex"
      ></confirmComponent>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //$t('mall.左边栏')
import Header from "./header.vue"; //$t('mall.头')
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //$t('mall.分页')
import { confirmComponent } from "@components/components.js"; //$t('mall.$t('mall.删除')确认')

export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('mall.左边栏')状态
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("mall-label-rowsPerPage"))
        ? parseInt(store.get("mall-label-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      filterProps: {
        status: "",
        type: "",
        clickType: "",
      },
      modalNewAD: {
        loading: false,
        imgUrl: "",
        uploadType: 1,
        status: "",
        priceRange1: 0,
        priceRange2: "",
        productName: "",
        clickType: "",
        type: "",
        cId: "",
        cIdName: "",
        id: "",
      },
      modalNewADDefault: "{}",
      modalMallLabel: {
        loading: false,
        list: [],
      },
      delAddr: {
        modalId: "modalDelAD",
        title: this.$t("mall.删除广告"),
        text: this.$t("mall.确定要删除该广告吗"),
        delIndex: "",
      },
      video_url: "",
      scale: false,
      ADSize: {
        1: "800*450",
        2: "150*n",
        3: "1200*150",
        4: "1000*150",
        5: "200*100",
      },
    };
  },
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("mall-AD-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
    this.modalNewADDefault = JSON.stringify(this.modalNewAD);
  },
  updated() {},
  methods: {
    editAD(item) {
      this.modalNewAD.id = item.id;
      this.modalNewAD.imgUrl = item.imgUrl;
      this.modalNewAD.uploadType = item.pathType == "img" ? 1 : 2;
      this.modalNewAD.status = item.status;
      this.modalNewAD.priceRange1 = item.paramsJson.min
        ? item.paramsJson.min
        : 0;
      this.modalNewAD.priceRange2 = item.paramsJson.max;
      this.modalNewAD.productName = item.paramsJson.productName;
      this.modalNewAD.clickType = item.clickType;
      this.modalNewAD.type = item.type;
      this.modalNewAD.cId = item.paramsJson.cId;
      this.modalNewAD.cIdName = item.paramsJson.cName;
      let vm = this;
      vm.scale = false;
      let img = new Image();
      img.src = this.modalNewAD.imgUrl;
      img.onload = function () {
        if (img.width > img.height) {
          vm.$set(vm, "scale", true);
        }
      };
      $("#modalNewAD").modal("show");
    },
    updateItems(id) {
      this.loading = true;
      $.api_call(
        "api.SupplierMallAD.findBySupplier",
        {
          id: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deletesFn() {
      //this.$t('mall.删除')
      this.loading = true;
      $.api_call(
        "api.SupplierMallAD.deleteBySupplier",
        {
          id: this.delAddr.delIndex,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $(`#${this.delAddr.modalId}`).modal("hide");
            ShowTip(this.$t("mall.删除广告成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    deleteAD(item) {
      this.delAddr.delIndex = item.id;
      $("#" + this.delAddr.modalId).modal("show");
    },
    saveNewADLabel() {
      this.modalMallLabel.list.forEach((e) => {
        if (e.id == this.modalNewAD.cId) {
          this.modalNewAD.cIdName = e.name;
        } else {
          if (e.chlidren && e.chlidren.length > 0) {
            e.chlidren.forEach((s) => {
              if (s.id == this.modalNewAD.cId) {
                this.modalNewAD.cIdName = s.name;
              }
            });
          }
        }
      });
      $("#modalNewAD").modal("show");
      $("#modalMallLabel").modal("hide");
    },
    modalNewADLabel() {
      this.loading = true;
      $.api_call("api.SupplierProductCategorys.findBySupplier", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.modalMallLabel.list = r.Data.Results;
          $("#modalNewAD").modal("hide");
          $("#modalMallLabel").modal("show");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    saveNewAD() {
      if (!this.modalNewAD.status) {
        ShowTip(this.$t("mall.请选择广告状态"), "danger");
        return;
      }
      this.modalNewAD.loading = false;
      let params = {
        type: this.modalNewAD.type,
        clickType: this.modalNewAD.clickType,
        status: this.modalNewAD.status,
        jsons: {
          productName: this.modalNewAD.productName,
          priceRange: `${this.modalNewAD.priceRange1}-${this.modalNewAD.priceRange2}`,
          cId: this.modalNewAD.cId,
          urlPath: this.modalNewAD.urlPath,
        },
        imgUrl: this.modalNewAD.imgUrl,
      };
      let url = !this.modalNewAD.id
        ? "api.SupplierMallAD.addBySupplier"
        : "api.SupplierMallAD.changeBySupplier";
      let tx = !this.modalNewAD.id
        ? this.$t("mall.添加广告成功")
        : this.$t("mall.修改广告成功");
      if (this.modalNewAD.id) {
        params.id = this.modalNewAD.id;
      }
      $.api_call(url, params, (r) => {
        this.modalNewAD.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(tx, "success");
          $("#modalNewAD").modal("hide");
          $("#modalMallLabel").modal("hide");
          if (this.modalNewAD.id) {
            this.updateItems(this.modalNewAD.id);
            return;
          }
          this.getItems();
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    fileClick2() {
      document.getElementById("upload_file_btn3").click();
    },
    fileUpload(el) {
      this.modalNewAD.loading = true;
      $.api_call(
        "api.SupplierMallAD.uploadFiles",
        {
          "@file": el.target.files[0],
        },
        (r) => {
          this.modalNewAD.loading = false;
          if (r.ErrorCode == "9999") {
            this.modalNewAD.imgUrl = r.Data.Results;
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    fileClick() {
      document.getElementById("upload_file_btn2").click();
    },
    imgBase64(event) {
      let vm = this;
      let el = event.target;
      if (el.value) {
        //转base64
        base64Image({
          width: 99999999,
          file: el,
          callback: (rst) => {
            let ext = "";
            let extArr = rst.match(/data:image\/(.*);base64,.*/);
            ext = extArr[1];
            let base64 = rst.split("base64,").pop();
            this.modalNewAD.loading = true;
            $.api_call(
              "api.SupplierMallAD.uploadFiles",
              {
                imgUrlBase64: base64,
                ext: ext,
              },
              (r) => {
                this.modalNewAD.loading = false;
                if (r.ErrorCode == "9999") {
                  this.modalNewAD.imgUrl = r.Data.Results;
                  vm.scale = false;
                  let img = new Image();
                  img.src = this.modalNewAD.imgUrl;
                  img.onload = function () {
                    if (img.width > img.height) {
                      vm.$set(vm, "scale", true);
                    }
                  };
                } else {
                  if (r.ErrorCode == "1002") {
                    userFailure(this);
                  } else {
                    ShowTip(r.Message, "danger");
                  }
                }
              }
            );
          },
        });
      }
    },
    addNew() {
      //打开添加修改
      this.modalNewAD = JSON.parse(this.modalNewADDefault);
      $("#modalNewAD").modal("show");
    },
    getItems() {
      if (!this.isSysRights("SupplierMallAD.findBySupplier")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        status: this.filterProps.status,
        type: this.filterProps.type,
        clickType: this.filterProps.clickType,
      };
      $.api_call("api.SupplierMallAD.findBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    move(item, type) {
      //上移下移
      let tx = type == 1 ? this.$t("mall.上移成功") : this.$t("mall.下移成功");
      this.loading = true;
      $.api_call(
        "api.SupplierMallAD.moveBySupplier",
        {
          id: item.id,
          type: type,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            ShowTip(tx, "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    clearKey(type) {
      this.filterProps[type] = "";
      this.toPage(1);
    },
    filtrate(status, type, clickType) {
      (this.filterProps = {
        status,
        type,
        clickType,
      }),
        this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/mall-AD/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/mall-AD/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
</style>